<template>
  <div>
    <input
      type="text"
      :class="{ 'invalid': $v.$invalid || error }"
      :name="inputName"
      :id="inputId"
      :title="inputTitle"
      :placeholder="inputPlaceholder"
      :value="value"
      :readonly="readonly"
      @input="inputHandler"
    />
    <label :for="inputId">
      <span :class="iconClass">{{ inputTitle }}</span>
    </label>
  </div>
</template>

<script>
import { requiredIf, minLength, maxLength } from 'vuelidate/lib/validators';

export default {
  name: 'InputText',
  props: {
    value: [Number, String],
    inputName: String,
    inputId: String,
    inputTitle: String,
    iconClass: String,
    inputPlaceholder: String,
    required: {
      type: Boolean,
      default() {
        return false;
      },
    },
    minLength: {
      type: Number,
      default() {
        return 0;
      },
    },
    maxLength: {
      type: Number,
      default() {
        return 255;
      },
    },
    readonly: {
      type: Boolean,
      default() {
        return false;
      },
    },
    error: {
      type: Boolean,
      default: () => false,
    },
  },
  validations() {
    return {
      value: {
        required: requiredIf(() => this.required),
        minLength: minLength(this.minLength),
        maxLength: maxLength(this.maxLength),
      },
    };
  },
  methods: {
    inputHandler(e) {
      this.$emit('input', e.target.value.trim());
      this.$v.$touch();
    },
  },
};
</script>
